import { initializeApp } from 'firebase/app';
import { getDatabase, ref } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyAAUf4JuqgepK-3F_lwYO7qsAiCJ2Yrg_Q',
  authDomain: 'robot-29bf8.firebaseapp.com',
  databaseURL: 'https://robot-29bf8-default-rtdb.firebaseio.com',
  projectId: 'robot-29bf8',
  storageBucket: 'robot-29bf8.appspot.com',
  messagingSenderId: '160591787945',
  appId: '1:160591787945:web:099d70e9818eea5c2076b8',
  measurementId: 'G-4WZ1YDXZ4P',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export default database;
